import Vue from "vue";
import Router from "vue-router";

import StartPage from "@/pages/start";
import ProgramPage from "@/pages/program";
import PartyPage from "@/pages/party";
import DirectionsPage from "@/pages/directions";
import FAQPage from "@/pages/faq";
import RecommendationsPage from "@/pages/recommendations";
import TicketsPage from "@/pages/tickets";
import PrivacyPage from "@/pages/privacy";
import ContactPage from "@/pages/contact";
import ImpressumPage from "@/pages/impressum";
import NewsletterPage from "@/pages/newsletter";
import NewsletterConfirmPage from "@/pages/newsletter/confirm";
import NewsletterCancelPage from "@/pages/newsletter/cancel";
import TicketShopProxyPage from "@/pages/ticket-shop-proxy";
import AuthenticationPage from "@/pages/authentication";
import ScreensaverPage from "@/pages/screensaver";

import TicketRequestAdministrationPage from "@/pages/admin/TicketRequests";
import PageReloadAdministrationPage from "@/pages/admin/Reloads";
import QuotasAdministrationPage from "@/pages/admin/Quotas";

import FormVerificationComponent from "@/components/signup-form/form-submit";

import DidiLayout from "@/layouts/didi";

Vue.use(Router);

const ticketsAvailable = process.env.VUE_APP_TICKETS_AVAILABLE === "true";

let activatedViews = [
  {
    path: "/",
    name: "root",
    component: StartPage,
  },
  {
    path: "start",
    name: "start",
    component: StartPage,
  },
  {
    path: "program",
    name: "program",
    alias: ["save-the-date"],
    component: ProgramPage,
  },
  {
    path: "party",
    name: "party",
    component: PartyPage,
  },
  {
    path: "faq",
    name: "faq",
    component: FAQPage,
  },
  {
    path: "ticket/order/:ticketShopId",
    name: "ticket-order-proxy",
    props: true,
    component: TicketShopProxyPage,
  },
  {
    path: "directions",
    name: "directions",
    component: DirectionsPage,
  },
  {
    path: "recommendations",
    name: "recommendations",
    component: RecommendationsPage,
  },
  {
    path: "privacy",
    name: "privacy",
    component: PrivacyPage,
  },
  {
    path: "impressum",
    name: "impressum",
    component: ImpressumPage,
  },
  {
    path: "contact",
    alias: ["newsletter"],
    name: "contact",
    component: ContactPage,
  },
  {
    path: "newsletter-confirm",
    component: NewsletterConfirmPage,
  },
  {
    path: "newsletter-cancel",
    component: NewsletterCancelPage,
  },
  {
    path: "auth",
    component: AuthenticationPage,
  },
  {
    path: "newsletter/:id",
    name: "single-newsletter",
    component: NewsletterPage,
  },
];

if (ticketsAvailable) {
  activatedViews.push({
    path: "tickets",
    name: "tickets",
    alias: ["ticket"],
    component: TicketsPage,
  });
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (window.innerWidth > 1000) {
      return;
    }

    return {
      selector: "#main-content-anchor",
    };
  },
  routes: [
    {
      path: "/",
      component: DidiLayout,
      children: activatedViews,
    },
    {
      path: "/screensaver",
      component: ScreensaverPage,
    },
    // internal component routes
    {
      path: "/_form/form-transmit",
      component: FormVerificationComponent,
      props: (route) => ({
        formId: route.query.formId,
        transmissionPIN: route.query.pin,
        autoTransmit: true,
      }),
    },
    {
      path: "/admin",
      name: "admin",
      component: DidiLayout,
      children: [
        {
          path: "ticket-request",
          name: "ticketRequestAdmin",
          component: TicketRequestAdministrationPage,
        },
        {
          path: "page-reloads",
          name: "pageReloadAdmin",
          component: PageReloadAdministrationPage,
        },
        {
          path: "quotas",
          name: "quotasAdmin",
          component: QuotasAdministrationPage,
        },
      ],
    },
  ],
});
